import axios from '../utils/axios';

export const logout = async () => {
    return axios({
        method: 'delete',
        url: '/api/permission/auth/logout'
    });
};
